/**
 * 检测当前设备是否为移动端
 * @returns {boolean} 如果是移动端设备返回true，否则返回false
 */
export function isMobile() {
  // 1. 首先检查用户代理中的明确移动设备标识
  const userAgent = navigator.userAgent.toLowerCase()
  const mobileKeywords = ['android', 'iphone', 'ipod', 'windows phone', 'mobile', 'blackberry']
  
  for (const keyword of mobileKeywords) {
    if (userAgent.indexOf(keyword) > -1) {
      return true
    }
  }
  
  // 2. 检查窗口宽度（只有在小屏幕时才判断为移动端）
  const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  
  if (windowWidth <= 768) {
    return true
  }
  
  // 3. iPad 特殊处理（iPad 的用户代理可能不包含 'mobile'）
  if (userAgent.indexOf('ipad') > -1) {
    return true
  }
  
  // 移除触摸事件检测，因为很多PC也支持触摸
  return false
}

/**
 * 检测当前设备是否为平板
 * @returns {boolean} 如果是平板设备返回true，否则返回false
 */
export function isTablet() {
  // 检查窗口宽度是否在平板范围内
  const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  if (windowWidth > 768 && windowWidth <= 1024) {
    return true
  }
  
  // 检查iPad
  const userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('ipad') > -1) {
    return true
  }
  
  // 检查Android平板
  if (userAgent.indexOf('android') > -1 && userAgent.indexOf('mobile') === -1) {
    return true
  }
  
  return false
}

/**
 * 监听视口变化，执行相应回调函数
 * @param {Function} callback 窗口大小变化时执行的回调函数
 * @returns {Function} 移除监听器的函数
 */
export function addResizeListener(callback) {
  window.addEventListener('resize', callback)
  
  // 返回一个函数用于清除监听
  return () => {
    window.removeEventListener('resize', callback)
  }
} 